var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-8",
    d: "M85.45,418c88.76,45.38,232.67,45.38,321.42,0s88.76-119,0-164.33-232.66-45.38-321.42,0S-3.3,372.63,85.45,418Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-8",
    d: "M375.73,345.51c4.87,2.81,14.43,1.84,21.35-2.16L437,320.16c6.93-4,8.59-9.52,3.72-12.34S426.3,306,419.37,310l-39.9,23.21C372.54,337.18,370.87,342.7,375.73,345.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-8",
    points: "135.31 366.9 94.69 343.45 135.31 320 135.31 366.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-8",
    points: "250.12 380.93 184.65 343.11 250.13 305.36 250.12 380.93",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.36,312.07c.12-9.5-6.52-29.27-16.23-41.72S39,248.69,28,252.32c-10.3,3.39-9.35,16.85,3,25.92s30.9,20.49,36.19,36l11.25,19Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.36,312.07c.12-9.5-6.52-29.27-16.23-41.72S39,248.69,28,252.32c-10.3,3.39-9.35,16.85,3,25.92s30.9,20.49,36.19,36l11.25,19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91,325.08a.69.69,0,0,1-.62-.57c-6-32.51-31.9-59.19-47.53-65.2a.7.7,0,1,1,.5-1.3c15.93,6.13,42.33,33.25,48.39,66.25a.69.69,0,0,1-.55.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.82,345.78c-1.46-5.36-7.88-14.25-18.34-21.66-11.58-8.19-26.3-12.07-29.63-18.38-4-7.58,2.43-14.62,14.4-13S75.1,311,78.18,335.66Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.21,340.2a.7.7,0,0,1-.6-.46C68,311.83,46.92,301.82,37.12,300.43a.69.69,0,0,1,.19-1.37c10.84,1.54,31.81,11.74,41.62,40.22a.71.71,0,0,1-.43.89A.74.74,0,0,1,78.21,340.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.93,285s1.33-20,13.13-34.9,11.08-21,2.94-24S424,241.05,428.16,265,434.93,285,434.93,285Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.93,285s1.33-20,13.13-34.9,11.08-21,2.94-24S424,241.05,428.16,265,434.93,285,434.93,285Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.32,273.58a.47.47,0,0,1-.47-.43c-1.37-22.06,14.2-40.16,20-44.26a.45.45,0,0,1,.64.11.47.47,0,0,1-.11.65c-5.72,4-21,21.77-19.64,43.44a.47.47,0,0,1-.43.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.72,301.56A105.38,105.38,0,0,0,448,305.48c9.14,1.44,13.18-2.93,13.18-2.93s-3.6-8.57-8.79-11a51.11,51.11,0,0,1,15.86,6.51s5.58.09,7.8-8.43c0,0-3.3-5.13-14.4-7.9,0,0,6.75-1.7,16.48.78.73.29,3.84-10.72,4.78-15.8s-1.1-5-5.06-6.09-17.09-4-19.57-1.83-3.74,9.63-3.74,9.63a17.58,17.58,0,0,1-.37-9.44s-3.56-1.39-9.1.22c-4.52,1.31-4.74,4.39-4.54,7.87a33.87,33.87,0,0,0,2,8.84s-3.53-4.52-3.64-14.33c0,0-9.26,4.6-10.84,13.8C427.13,280.37,425.91,295,431.72,301.56Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.46,299.78a.53.53,0,0,0,.47-.29c7.37-15.33,34.8-33.14,44.62-35.05a.51.51,0,0,0,.41-.6.53.53,0,0,0-.61-.41c-10,1.95-37.86,20-45.35,35.61a.52.52,0,0,0,.24.69A.59.59,0,0,0,433.46,299.78Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--computer-screen--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.78,352.86c-1.13,0-1.81-.93-1.81-2.5V182.15L281,63.22V230.75a8.93,8.93,0,0,1-4,7L78.42,352.35a3.33,3.33,0,0,1-1.64.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.38,64.23V230.75a8.45,8.45,0,0,1-3.75,6.49L78.13,351.84a2.77,2.77,0,0,1-1.35.44c-1.11,0-1.23-1.35-1.23-1.92V182.49L280.38,64.23m1.17-2L74.38,181.81V350.36c0,2,1,3.09,2.4,3.09a3.92,3.92,0,0,0,1.93-.59L277.22,238.25a9.58,9.58,0,0,0,4.33-7.5V62.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.39 181.81 74.39 209.96 281.55 90.35 281.55 62.2 74.39 181.81",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.63,183.31v4c0,.82.59,1.16,1.3.75l63.69-36.77v-7L91.93,181.06A2.91,2.91,0,0,0,90.63,183.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45,140.35c.72-.42,1.3-.08,1.3.75v4a2.89,2.89,0,0,1-1.3,2.25l-6.83,3.94v-7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.38,172.74a9.58,9.58,0,0,1,4.33-7.5L277.22,50.63c2.39-1.38,4.33-.26,4.33,2.5V62.2L74.38,181.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.52,66.14a4.47,4.47,0,0,0-2,3.51c0,1.3.91,1.82,2,1.18a4.49,4.49,0,0,0,2-3.52C260.56,66,259.65,65.49,258.52,66.14Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,62.42a4.47,4.47,0,0,0-2,3.51c0,1.3.91,1.82,2,1.18a4.51,4.51,0,0,0,2-3.52C267,62.29,266.08,61.77,265,62.42Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,58.7a4.47,4.47,0,0,0-2,3.51c0,1.3.91,1.82,2,1.18a4.51,4.51,0,0,0,2-3.52C273.42,58.57,272.51,58.05,271.39,58.7Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.55,108.67a9.82,9.82,0,0,0-4.43,7.7c0,2.83,2,4,4.43,2.56a9.8,9.8,0,0,0,4.44-7.69C221,108.41,219,107.26,216.55,108.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.25,120.4a9.8,9.8,0,0,0-4.44,7.69c0,2.83,2,4,4.44,2.57a9.82,9.82,0,0,0,4.43-7.7C200.68,120.13,198.7,119,196.25,120.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.86,97a9.8,9.8,0,0,0-4.43,7.69c0,2.83,2,4,4.43,2.56a9.79,9.79,0,0,0,4.44-7.69C241.3,96.68,239.32,95.53,236.86,97Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.18,85.2a9.8,9.8,0,0,0-4.44,7.69c0,2.83,2,4,4.44,2.56a9.8,9.8,0,0,0,4.44-7.69C261.62,84.93,259.63,83.78,257.18,85.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M95,212.15l48.21-27.84c2.39-1.38,4.33-.26,4.33,2.5V233.1a9.58,9.58,0,0,1-4.33,7.5L95,268.43c-2.39,1.38-4.33.26-4.33-2.5V219.65A9.58,9.58,0,0,1,95,212.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,172.28,265,114c2.39-1.39,4.33-.27,4.33,2.5v46.28a9.58,9.58,0,0,1-4.33,7.5L164,228.56c-2.39,1.38-4.33.26-4.33-2.5V179.78A9.58,9.58,0,0,1,164,172.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,282.5l76.64-44.25c2.4-1.38,4.34-.4,4.34,2.19a9.29,9.29,0,0,1-4.33,7.19L95,291.88c-2.39,1.38-4.33.4-4.33-2.19A9.29,9.29,0,0,1,95,282.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,298.92l76.64-44.25c2.4-1.38,4.34-.4,4.34,2.19a9.29,9.29,0,0,1-4.33,7.19L95,308.3c-2.39,1.38-4.33.4-4.33-2.19A9.29,9.29,0,0,1,95,298.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,315.33l76.64-44.25c2.4-1.38,4.34-.4,4.34,2.19a9.29,9.29,0,0,1-4.33,7.19L95,324.71c-2.39,1.38-4.33.4-4.33-2.19A9.29,9.29,0,0,1,95,315.33Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letter--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.25,259.67a5.77,5.77,0,0,1,2.6-4.5l132.91-76.73a5.74,5.74,0,0,1,5.2,0l2.93,1.69a5.74,5.74,0,0,1,2.59,4.5V286.51a5.76,5.76,0,0,1-2.59,4.5L142,367.74a5.74,5.74,0,0,1-5.2,0l-2.93-1.69a5.76,5.76,0,0,1-2.6-4.5Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,257.11l7.38,4.26,137.33-79.3a5.47,5.47,0,0,0-1.83-1.95L272,178.44a5.7,5.7,0,0,0-5.18,0L133.85,255.17A5.38,5.38,0,0,0,132,257.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,259.67V361.55a5.76,5.76,0,0,0,2.6,4.5l2.93,1.69a3.83,3.83,0,0,0,.71.32,5.78,5.78,0,0,0,1.07.25,6.4,6.4,0,0,0,2.05-.08,3.8,3.8,0,0,0,.51-.13l.31-.12a1.58,1.58,0,0,1-1.25,0,1.8,1.8,0,0,1-.79-1.71V264.37a2.29,2.29,0,0,1,1.35-2.22l-1.35-.78L132,257.11A5.32,5.32,0,0,0,131.25,259.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.39,261.37l61.55,23a10,10,0,0,0,11.87-3.91l9.88-15.14,54.52-83.53-52.55,84.1,52.82,20.67a5.37,5.37,0,0,1-.81,2.59l-52.15-23L213,284.5a10,10,0,0,1-12.52,3.84l-8.18-3.61L140.18,368a1.8,1.8,0,0,1-.79-1.71v-1.69l52.68-79.93Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile-screen--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.05,144.41v233.9c0,2.76,1.94,3.88,4.33,2.5l105.08-60.67a9.58,9.58,0,0,0,4.33-7.5V78.74c0-2.76-1.94-3.88-4.33-2.5L253.38,136.91A9.56,9.56,0,0,0,249.05,144.41Z",
    style: {
      fill: "#fafafa",
      stroke: "#e0e0e0",
      strokeMiterlimit: 10,
      strokeWidth: "1.16981px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,148.76a2.39,2.39,0,0,1,1.13-1.82l12-6.91c.62-.36,1.12-.12,1.12.53a2.38,2.38,0,0,1-1.12,1.82l-12,6.91C255.65,149.65,255.14,149.41,255.14,148.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,153.42a2.38,2.38,0,0,1,1.13-1.82l12-6.91c.62-.36,1.12-.12,1.12.52a2.38,2.38,0,0,1-1.12,1.83l-12,6.9C255.65,154.3,255.14,154.07,255.14,153.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,158.08a2.38,2.38,0,0,1,1.13-1.82l12-6.91c.62-.36,1.12-.13,1.12.52a2.36,2.36,0,0,1-1.12,1.82l-12,6.91C255.65,159,255.14,158.73,255.14,158.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.67,98.1V96.23a.13.13,0,0,0-.19-.12l-1.44.65a.17.17,0,0,1-.24-.11,3.07,3.07,0,0,0-.32-.71.39.39,0,0,1,0-.35l1-1.94a.21.21,0,0,0-.09-.28l-1-.6a.22.22,0,0,0-.28.07l-1.2,1.8a.37.37,0,0,1-.31.15,3.56,3.56,0,0,0-.78.08.17.17,0,0,1-.22-.15l-.16-1.57c0-.11-.1-.16-.19-.1l-1.62.93a.43.43,0,0,0-.19.3l-.16,1.8a.65.65,0,0,1-.17.34,9,9,0,0,0-.9,1,.3.3,0,0,1-.32.09l-1-.36a.25.25,0,0,0-.29.11l-1.19,2.06a.26.26,0,0,0,.05.3l.84.72a.32.32,0,0,1,.08.32,10.06,10.06,0,0,0-.38,1.26.62.62,0,0,1-.2.31l-1.48,1a.44.44,0,0,0-.17.32v1.86a.12.12,0,0,0,.19.12l1.44-.65a.18.18,0,0,1,.24.12,3.07,3.07,0,0,0,.32.71.39.39,0,0,1,0,.35l-1,1.93a.23.23,0,0,0,.09.29l1,.6a.22.22,0,0,0,.28-.07l1.2-1.8a.37.37,0,0,1,.31-.15,3.56,3.56,0,0,0,.78-.08.17.17,0,0,1,.22.15l.16,1.57c0,.11.09.16.19.1l1.62-.93a.46.46,0,0,0,.19-.31l.16-1.8a.59.59,0,0,1,.17-.33,9,9,0,0,0,.9-1,.3.3,0,0,1,.32-.09l1,.36a.25.25,0,0,0,.29-.11l1.19-2.06a.26.26,0,0,0-.06-.31l-.83-.71a.32.32,0,0,1-.08-.32,10.06,10.06,0,0,0,.38-1.26.54.54,0,0,1,.2-.31l1.48-1A.46.46,0,0,0,354.67,98.1ZM348.34,104c-1.51.88-2.73.17-2.73-1.57a6,6,0,0,1,2.73-4.74c1.51-.87,2.73-.16,2.73,1.58A6,6,0,0,1,348.34,104Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92,144.2c12.28-7.09,22.23-1.34,22.23,12.84s-9.95,31.41-22.23,38.5-22.23,1.34-22.23-12.83S293.64,151.29,305.92,144.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,155.36c4-2.3,7.21-.44,7.21,4.16A15.94,15.94,0,0,1,305.77,172c-4,2.3-7.22.44-7.22-4.16A15.93,15.93,0,0,1,305.77,155.36Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,179.88c0-7.55-5.31-10.62-11.85-6.84L304,175.4c-6.54,3.78-11.85,13-11.85,20.53V198a12.43,12.43,0,0,0,3.82.59,20.14,20.14,0,0,0,9.91-3A43.81,43.81,0,0,0,320,181.64Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.86,216.63,326,193.46c1.19-.69,2.16-.2,2.16,1.1a4.65,4.65,0,0,1-2.16,3.59l-40.13,23.17c-1.2.7-2.17.2-2.17-1.09A4.64,4.64,0,0,1,285.86,216.63Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.55,233.21,330.29,205c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59L281.55,237.9c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,281.55,233.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.59,227.74l13.65-7.88c.72-.41,1.3-.22,1.3.43a2.61,2.61,0,0,1-1.3,1.92l-13.65,7.88c-.71.41-1.3.22-1.3-.42A2.64,2.64,0,0,1,331.59,227.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4,262.43l20.05-11.57c1.19-.69,2.16-.13,2.16,1.25v13.76a4.8,4.8,0,0,1-2.16,3.75L263.4,281.19c-1.19.69-2.16.13-2.16-1.25V266.18A4.8,4.8,0,0,1,263.4,262.43Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.6,264.35l13.65-7.88c.72-.41,1.3-.22,1.3.42a2.61,2.61,0,0,1-1.3,1.93L266.6,266.7c-.72.41-1.3.22-1.3-.42A2.61,2.61,0,0,1,266.6,264.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,271.29v4c0,.83.58,1.16,1.3.75l13.65-7.88a2.87,2.87,0,0,0,1.3-2.25v-4c0-.83-.58-1.16-1.3-.75L266.6,269A2.89,2.89,0,0,0,265.3,271.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.9,243.67l20-11.57c1.2-.69,2.17-.13,2.17,1.25v13.76a4.78,4.78,0,0,1-2.17,3.75l-20,11.57c-1.2.69-2.16.13-2.16-1.25V247.42A4.77,4.77,0,0,1,295.9,243.67Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.1,245.59l13.65-7.88c.71-.41,1.29-.22,1.29.42a2.63,2.63,0,0,1-1.29,1.93l-13.65,7.88c-.72.41-1.3.22-1.3-.43A2.61,2.61,0,0,1,299.1,245.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8,252.53v4c0,.83.58,1.16,1.3.75l13.65-7.88a2.89,2.89,0,0,0,1.29-2.25v-4c0-.83-.59-1.16-1.3-.75l-13.65,7.88A2.87,2.87,0,0,0,297.8,252.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.4,224.91l20-11.58c1.19-.69,2.16-.13,2.16,1.25v13.77a4.8,4.8,0,0,1-2.16,3.75l-20,11.57c-1.2.69-2.17.13-2.17-1.25V228.66A4.78,4.78,0,0,1,328.4,224.91Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.59,226.83,345.24,219c.72-.42,1.3-.23,1.3.42a2.58,2.58,0,0,1-1.3,1.92l-13.65,7.88c-.71.42-1.3.23-1.3-.42A2.61,2.61,0,0,1,331.59,226.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.29,233.77v4c0,.82.59,1.16,1.3.75l13.65-7.89a2.86,2.86,0,0,0,1.3-2.25v-4c0-.83-.58-1.17-1.3-.75l-13.65,7.88A2.88,2.88,0,0,0,330.29,233.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.57,294l80.7-46.59c2.4-1.38,4.33-.4,4.33,2.19a9.26,9.26,0,0,1-4.33,7.19l-80.7,46.59c-2.39,1.38-4.33.4-4.33-2.19A9.29,9.29,0,0,1,265.57,294Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.57,312.77l80.7-46.59c2.4-1.38,4.33-.4,4.33,2.19a9.26,9.26,0,0,1-4.33,7.19l-80.7,46.6c-2.39,1.38-4.33.4-4.33-2.2A9.29,9.29,0,0,1,265.57,312.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.84,321.06,320,304.8c1.2-.69,2.17-.13,2.17,1.25v9.07a4.78,4.78,0,0,1-2.17,3.75l-28.16,16.26c-1.2.69-2.17.13-2.17-1.25v-9.07A4.78,4.78,0,0,1,291.84,321.06Z",
    style: {
      fill: "#39A270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,295.39a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C269.36,295.27,268.45,294.74,267.33,295.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.77,291.67a4.47,4.47,0,0,0-2,3.52c0,1.29.9,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C275.8,291.55,274.89,291,273.77,291.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,288a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C282.23,287.83,281.32,287.3,280.2,288Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64,284.23a4.48,4.48,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C288.67,284.11,287.76,283.58,286.64,284.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07,280.51a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C295.1,280.39,294.19,279.86,293.07,280.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5,276.79a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.47,4.47,0,0,0,2-3.52C301.53,276.67,300.63,276.14,299.5,276.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.94,273.07a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C308,273,307.06,272.42,305.94,273.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,314.17a4.51,4.51,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.47,4.47,0,0,0,2-3.51C269.36,314.05,268.45,313.53,267.33,314.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.77,310.45a4.48,4.48,0,0,0-2,3.52c0,1.3.9,1.82,2,1.17a4.47,4.47,0,0,0,2-3.51C275.8,310.33,274.89,309.81,273.77,310.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,306.73a4.51,4.51,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.47,4.47,0,0,0,2-3.51C282.23,306.61,281.32,306.08,280.2,306.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64,303a4.49,4.49,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.47,4.47,0,0,0,2-3.51C288.67,302.89,287.76,302.36,286.64,303Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07,299.29a4.49,4.49,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.47,4.47,0,0,0,2-3.51C295.1,299.17,294.19,298.64,293.07,299.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5,295.57a4.49,4.49,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.45,4.45,0,0,0,2-3.52C301.53,295.45,300.63,294.92,299.5,295.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.94,291.85a4.49,4.49,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.48,4.48,0,0,0,2-3.52C308,291.73,307.06,291.2,305.94,291.85Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Key--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.19,334.13a19.45,19.45,0,0,1-9.85-2.6c-7.21-4.17-11.34-12.87-11.34-23.9,0-19.38,12.32-41.67,28-50.75,8.47-4.89,16.88-5.42,23.69-1.49,7.2,4.16,11.34,12.87,11.34,23.89,0,19.38-12.32,41.68-28.05,50.76A27.9,27.9,0,0,1,396.19,334.13Zm20.66-67.38A14.76,14.76,0,0,0,410,269C398.6,275.55,389,293.26,389,307.63c0,5.82,1.63,10.24,4.36,11.81,3.11,1.8,7.44-.16,9.73-1.49,11.43-6.59,21.07-24.3,21.07-38.67,0-5.82-1.63-10.23-4.36-11.81A5.68,5.68,0,0,0,416.85,266.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.61,282.38c0-10.89-6.86-14.91-6.86-14.91h0c2.73,1.58,4.36,6,4.36,11.81,0,14.37-9.64,32.08-21.07,38.67-2.29,1.33-6.61,3.29-9.73,1.49,0,0,5.79,3.6,13.79-.77C418.68,312.36,426.61,296.75,426.61,282.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61,146.29a7.22,7.22,0,0,0-14.43,0v0h0V261h0a3.61,3.61,0,0,0,2.11,3,11.31,11.31,0,0,0,10.2,0,3.6,3.6,0,0,0,2.12-3h0V146.31h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.85,171.93a9.22,9.22,0,0,0-4.17-7.22,2.9,2.9,0,0,0-3-.26h0L384.9,174.7l-.43.25a.67.67,0,0,0-.18.11,6.25,6.25,0,0,0-.85.69,5.9,5.9,0,0,0,6.95,9.38l.34-.2,17.91-10.31h0A2.93,2.93,0,0,0,409.85,171.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.85,200.65a9.22,9.22,0,0,0-4.17-7.21,2.88,2.88,0,0,0-3-.27h0l-20.86,12-.43.25a.78.78,0,0,0-.18.11,5.69,5.69,0,0,0-.85.69,5.92,5.92,0,0,0,1.32,9.38,6,6,0,0,0,2.82.7,5.88,5.88,0,0,0,2.81-.7c.12-.06.23-.14.34-.2l21-12h0A2.93,2.93,0,0,0,409.85,200.65Z",
    style: {
      fill: "#455a64"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.d0cb90886ce6d6a698e9c01275ca6cee.svg";
export { ForwardRef as ReactComponent };